module.exports = __webpack_public_path__ + "static/media/content2.8f57a0d3.svg";